import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { useEvent, useUnit } from 'effector-react';
import { openModalEvent } from '@nx-frontend/shared/ui/modal/modal-store';
import { $orgInfo } from '@nx-frontend/shared/store/org-info';
import { $orgId } from '@nx-frontend/shared/store/portal-app';
import { PaywallPopupReason, PopupType } from '@nx-frontend/shared/types';
import { getPaywallTitle } from '@nx-frontend/shared/utils';

interface OpenPaywallPopupProps {
  reason?: PaywallPopupReason;
}

function useOpenPaywallPopup() {
  const [orgId, orgInfo] = useUnit([$orgId, $orgInfo]);
  const openModal = useEvent(openModalEvent);
  const { subscriptionType } = orgInfo;
  const modalContainerStyles = 'bg-transparent';
  const t = useTranslations();
  return useCallback(
    ({ reason }: OpenPaywallPopupProps = {}) => {
      openModal({
        content: PopupType.PAYWALL,
        showCloseButton: false,
        isFullScreen: true,
        modalContainerStyles,
        payload: {
          appName: 'portal',
          payloadType: PopupType.PAYWALL,
          title: getPaywallTitle(subscriptionType, t),
          reason,
          orgId,
          ...(subscriptionType && { subscriptionType }),
          escapeToClose: true,
        },
      });
    },
    [orgId, openModal, subscriptionType, modalContainerStyles, t]
  );
}

export default useOpenPaywallPopup;
